import { createAction } from 'redux-actions';

export const GENERATE_KEYS = 'GENERATE_KEYS';

export const generateKeys = createAction(GENERATE_KEYS);
